const $ = require("jquery");

$(function () {
  "use strict";
  function findAllSelectCategoryCheckboxes() {
    return $(".js-select-category").find('input[type="checkbox"]');
  }

  function findSelectCategoryCheckboxes(target) {
    return target.closest(".js-select-category").find('input[type="checkbox"]');
  }

  $(".js-all-select-category-button").on("click", function () {
    findAllSelectCategoryCheckboxes().each(function () {
      $(this).prop("checked", true);
    });
  });

  $(".js-all-select-category-clear-button").on("click", function () {
    findAllSelectCategoryCheckboxes().each(function () {
      $(this).prop("checked", false);
    });
  });

  $(".js-select-category-button").on("click", function () {
    findSelectCategoryCheckboxes($(this)).each(function () {
      $(this).prop("checked", true);
    });
  });

  $(".js-select-category-clear-button").on("click", function () {
    findSelectCategoryCheckboxes($(this)).each(function () {
      $(this).prop("checked", false);
    });
  });
});
